import { getAnalytics } from "@tm/insurance/analytics";
import { trackComponentView } from "@tm/insurance/analytics/xdm";
import { FlexComp, H2Tag, H5Tag, ImageComponent } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { useIntersectionObserver } from "@tm/ui/hooks";
import { useCallback, useRef } from "react";
import { InnerContentWrap } from "../../CommonStyle/CommonStyles.style";
import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";
import {
  SafenSecureBgWrap,
  SafenSecureTravStyle,
} from "./SafenSecureTrav.style";
import SafenSecureTravCrd from "./SafenSecureTravCrd";

interface SafenSecureTravProps {
  title?: TextNodeType;
  data?: {
    title: TextNodeType;
    featList: TextNodeType[];
    poweredBy: string[];
    additionalInfo?: TextNodeType;
    cardImg: string;
  }[];
}

const SafenSecureTrav = ({ title, data }: SafenSecureTravProps) => {
  const device = useBreakpointV2();
  const analytics = getAnalytics();
  const hasTracked = useRef<boolean>(false);

  // Track component view when it comes into viewport
  const handleIntersection = useCallback(() => {
    trackComponentView({
      name: "section_2_shown",
      type: "card",
    });
    if (!hasTracked.current) {
      analytics?.trackLandingEvents({
        actionType: "safe_n_secure_trav_seen",
      });
    }
    hasTracked.current = true;
  }, []);

  const { ref: intersectionRef } = useIntersectionObserver(handleIntersection, {
    threshold: 0.5, // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true,
  });

  return (
    <SafenSecureTravStyle ref={intersectionRef}>
      <SafenSecureBgWrap>
        <ImageComponent
          width="100%"
          height="558px"
          src="https://tripmoneycmsimgak.mmtcdn.com/img/safen_Secure_Bg_200cfd8d5c.svg"
        />
      </SafenSecureBgWrap>
      <InnerContentWrap>
        {device == "lg" ? (
          <H2Tag margin="0 0 60px">
            {title && <FormattedText value={title} />}
          </H2Tag>
        ) : (
          <H5Tag margin="0 0 20px">
            {title && <FormattedText value={title} />}
          </H5Tag>
        )}
        <FlexComp
          gap={device == "lg" ? "60px" : "20px"}
          flexDirection={device == "sm" ? "column" : "row"}
          flexWrap="wrap"
        >
          {data &&
            data.map((item, index: number) => {
              return (
                <SafenSecureTravCrd
                  key={index}
                  cardQuantity={data?.length}
                  {...item}
                />
              );
            })}
        </FlexComp>
      </InnerContentWrap>
    </SafenSecureTravStyle>
  );
};

export default SafenSecureTrav;
